
import React from 'react';
import SkillBadge from './SkillBadge';
import { Skill } from './types';

interface SkillCardProps {
  skillGroup: Skill;
  index: number;
  onHoverSkill: (skillName: string | null) => void;
}

const SkillCard: React.FC<SkillCardProps> = ({ skillGroup, index, onHoverSkill }) => {
  return (
    <div 
      className="bg-white rounded-xl p-6 shadow-md border border-sage-100 
                hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
    >
      <div className="flex items-center gap-3 mb-4">
        {skillGroup.icon}
        <h3 className="text-lg font-medium text-sage-800">{skillGroup.category}</h3>
      </div>
      
      <div className="flex flex-wrap gap-2 mt-4">
        {skillGroup.skills.map((skill, idx) => (
          <SkillBadge
            key={idx}
            name={skill.name}
            description={skill.description}
            expertise={skill.expertise}
            isEven={index % 2 === 0}
            onMouseEnter={() => onHoverSkill(skill.name)}
            onMouseLeave={() => onHoverSkill(null)}
          />
        ))}
      </div>
    </div>
  );
};

export default SkillCard;
